<template>
    <div class="row">
        <div v-if="editing" class="col-12 mb-1">
            <label class="form-label">Referans Numarası</label>
            <input class="form-control" :value="value.RefNumber" placeholder="-" disabled />
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Vukuat Tarihi ve Saati</label>
            <v-validator :errors="errors" parameter="Date" :watch="value.Date">
                <v-date-picker for-back type="datetime" v-model="value.Date" placeholder="Vukuat Tarihi" :disabled="editing" :disabled-date="disableFutureDates"></v-date-picker>
            </v-validator>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Personel Adı Giriniz...</label>
            <v-validator :errors="errors" parameter="EmployeeId" :watch="employee">
                <v-select-list
                    :disabled="!!!value.Date || editing"
                    :value="employee"
                    @input="handleEmployeeChange"
                    :options="employees"
                    v-on:search="searchEmployees"
                    label="Combine"
                    placeholder="Personel"
                    :loading="employeeLoading"
                    :filterable="false"
                ></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Vukuat Parametresi</label>
            <v-validator :errors="errors" parameter="Date" :watch="value.Date">
                <v-select-list v-model="caseType" label="Name" :disabled="editing" multiple placeholder="Vukuat Parametresi" :options="c_caseTypes" />
            </v-validator>
        </div>

        <div v-if="employee" class="col-12">
            <div class="row">
                <div class="col-lg-6 mb-1">
                    <label class="form-label">Şube</label>
                    <v-select-list v-model="selectedBranch" @input="handleBranchChange" label="Name" placeholder="Şube Seçiniz" :options="allBranches" :disabled="!value.EmployeeId || value.BaseOperationalBranchId != null" />
                </div>

                <div class="col-lg-6 mb-1">
                    <label class="form-label">Görev Yeri</label>
                    <v-select-list
                        v-model="selectedGarage"
                        @input="handleGarageChange"
                        label="GarageName"
                        placeholder="Görev Yeri Seçiniz"
                        :options="garageLocationsByBranch"
                        :clearable="true"
                        :loading="garagesLoading"
                        :disabled="!value.OperationalBranchId"
                    />
                </div>
            </div>
        </div>
        <!-- <div class="col-lg-6 mb-1">
            <label class="form-label mb-75">Vukuat Türü </label>
            <v-validator :errors="errors" parameter="IncidentReasonId" :watch="incidentReason">
                <v-select-list v-model="incidentReason" :options="incidentReasons" label="Name" placeholder="Vukuat Türü" :disabled="editing"></v-select-list>
            </v-validator>
        </div> -->
        <div class="col-lg-6 mb-1">
            <label class="form-label">Yaş</label>
            <input class="form-control" :value="$safe(employee, 'Age')" placeholder="-" disabled />
        </div>
        <div class="col-lg-6 mb-1">
            <div class="d-flex justify-content-between align-items-center" v-if="!editing">
                <label class="form-label mb-0"> Fatura var mı? </label>
                <b-form-checkbox :checked="hasInvoice" v-on:change="updateHasInvoice" switch></b-form-checkbox>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="editing">
                <label class="form-label"> Fatura Numarası </label>
            </div>
            <div>
                <v-validator :errors="errors" parameter="InvoiceNumber" :watch="value.InvoiceNumber">
                    <input class="form-control" v-model="value.InvoiceNumber" :disabled="!hasInvoice || editing" placeholder="Fatura Numarası Giriniz..." />
                </v-validator>
            </div>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Çekici Plaka</label>
            <v-validator :errors="errors" parameter="TruckPlateId" :watch="truckPlate">
                <v-select-list v-model="truckPlate" placeholder="Plaka" label="PlateValue" :options="truckPlates" :disabled="editing" />
            </v-validator>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Treyler Plaka</label>
            <v-validator :errors="errors" parameter="TrailerPlateId" :watch="trailerPlate">
                <v-select-list v-model="trailerPlate" placeholder="Plaka" label="PlateValue" :options="trailerPlates" :disabled="editing" />
            </v-validator>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="from-label">Maaş Dönemi</label>
            <select class="form-control" v-model="value.PaymentStartPeriod" :disabled="editing">
                <option :value="null" disabled v-if="value.PaymentStartPeriod == null">Seçiniz</option>
                <option v-for="sp in salaryPeriods" :key="sp" :value="sp">{{ sp }}</option>
            </select>
        </div>
        <div class="col-12 col-lg-6 mb-1">
            <label class="form-label">Ülke</label>
            <v-select-list v-model="country" placeholder="Ülke Seçiniz" label="Name" :options="countries" :disabled="editing" :clearable="false" />
        </div>
        <div class="col-12 col-lg-6 mb-1">
            <label class="form-label">İl</label>
            <v-select-list v-model="province" placeholder="İl Seçiniz" label="Name" :options="provinces" :disabled="!country || editing" />
        </div>
        <div class="col-12 col-lg-6 mb-1">
            <label class="form-label">İlçe</label>
            <v-select-list :disabled="!province || editing" placeholder="İlçe" v-model="district" label="Name" :options="districts" />
        </div>
        <div class="col-md-12 mb-1">
            <label class="form-label">Firma</label>
            <v-select-list v-model="firm" :options="firms" label="Name" v-on:search="searchFirms" placeholder="Firma Adı Giriniz..." :loading="firmsLoading" :disabled="editing"></v-select-list>
        </div>
        <!-- <div class="col-12 mb-1">
            <label class="form-label">Firma Konumu</label>
            <v-select-list :disabled="!firm || editing" placeholder="Firma Konumu" v-model="location" label="LocationName" :options="locations" :loading="locationsLoading" />
        </div> -->
        <div class="col-12" style="margin-top: 0.8rem">
            <div class="card mb-2" style="border: 1px #c9cdcf solid">
                <div class="card-body py-2">
                    <div class="row">
                        <div class="col-lg-6 mb-1">
                            <label class="form-label">Sürücü Ödeme Miktarı <span class="text-danger">*</span></label>
                            <v-validator :errors="errors" parameter="EmployeeAmount" :watch="value.EmployeeAmount">
                                <v-currency-input
                                    input-class="text-right"
                                    :value="value.EmployeeAmount"
                                    v-on:update-value="(currencyAmount) => (value.EmployeeAmount = currencyAmount)"
                                    v-on:blur.native="validatePositiveAmount('EmployeeAmount')"
                                ></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-lg-6 mb-1">
                            <label class="form-label">Firma Ödeme Miktarı <span class="text-danger">*</span></label>
                            <v-validator :errors="errors" parameter="CompanyAmount" :watch="value.CompanyAmount">
                                <v-currency-input
                                    input-class="text-right"
                                    :value="value.CompanyAmount"
                                    v-on:update-value="(currencyAmount) => (value.CompanyAmount = currencyAmount)"
                                    v-on:blur.native="validatePositiveAmount('CompanyAmount')"
                                ></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-lg-6 mb-1">
                            <label class="form-label">Sürücü Emanet Miktarı</label>
                            <v-validator :errors="errors" parameter="EmployeeDepositAmount" :watch="value.EmployeeDepositAmount">
                                <v-currency-input
                                    input-class="text-right"
                                    :value="value.EmployeeDepositAmount"
                                    v-on:update-value="(currencyAmount) => (value.EmployeeDepositAmount = currencyAmount)"
                                    v-on:blur.native="validatePositiveAmount('EmployeeDepositAmount')"
                                ></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-lg-6 mb-1">
                            <label class="form-label">Taksit Sayısı <span class="text-danger">*</span></label>
                            <v-validator :errors="errors" parameter="InstallmentCount" :watch="installmentCount">
                                <v-select-list v-model="installmentCount" :options="installments" label="name" placeholder="Taksit Sayısı"></v-select-list>
                            </v-validator>
                        </div>
                    </div>
                    <div class="d-flex justify-content-start align-items-center mt-50">
                        <span class="font-weight-bold h5 text-dark mr-50 mb-0"> Toplam Vukuat Tutarı: </span>
                        <b-badge variant="dark" style="font-size: 1rem; margin-bottom: 0.2rem">
                            {{ totalAmountFormatted }}
                        </b-badge>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mb-1 mt-0" v-if="calculateResult && calculateResult.length > 0">
            <table class="table table-bordered table-sm mb-0 mt-0">
                <thead>
                    <tr>
                        <th class="w-33">Taksit</th>
                        <th class="w-33">Ödeme Tarihi</th>
                        <th class="w-34">Tutar (TL)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ins, i) in calculateResult" :key="i">
                        <td>{{ ins.InstallmentOrder }}</td>
                        <td>{{ ins.PaymentPeriod }}</td>
                        <td>{{ ins.TotalAmountStr }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <v-validator :errors="errors" parameter="Description" :watch="value.Description">
                <textarea :disabled="editing" class="form-control resize-none" rows="3" placeholder="Açıklama" v-model="value.Description"></textarea>
            </v-validator>
        </div>
        <div class="col-12">
            <v-file-uploader :disabled="editing" :accept="['png', 'jpg', 'jpeg', 'pdf', 'xlsx', 'xls', 'doc', 'docx']" v-model="value" multiple value-parameter="Files" v-on:view="handleViewFile"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from "@/api/employee-operations";
import IncidentOperationsApi from "@/api/incident-operations";
import CompanyApi from "@/api/company";
import VehicleOperationsApi from "@/api/vehicle-operations";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import VFileUploader from "@/components/v-file-uploader/VFileUploader";
import moment from "moment";
import SystemDataApi from "@/api/system-data";
import FirmOperationsApi from "@/api/firm-operations";
import { BSpinner, BBadge, BFormCheckbox } from "bootstrap-vue";

export default {
    components: {
        VCurrencyInput,
        VFileUploader,
        BSpinner,
        BBadge,
        BFormCheckbox,
    },
    props: {
        value: Object,
        errors: Object,
        editing: Boolean,
        truckPlates: {
            type: Array,
            default: () => [],
        },
        trailerPlates: {
            type: Array,
            default: () => [],
        },
        hasInvoice: Boolean,
    },
    data() {
        return {
            selectedBranch: null,
            selectedGarage: null,
            employeeGarageOption: [],
            employeeLoading: false,
            employees: [],
            searchOnTableTimer: null,
            incidentReasons: [],
            caseTypes: [],
            installments: Array(36)
                .fill(0)
                .map((_, i) => ({ value: i + 1, name: `${i + 1} Taksit` })),
            calculateResult: [],
            calculating: false,
            calculateDebounceTimer: null,
            countries: [],
            provinces: [],
            districts: [],
            firms: [],
            firmsLoading: false,
            locationsLoading: false,
            locations: [],
            allBranches: [],
            garageLocationsByBranch: [],
            garagesLoading: false,
        };
    },
    watch: {
        "value.IncidentReasonId"() {
            this.value.TrailerPlateId = null;
            this.value.TruckPlateId = null;
        },
        "value.TruckPlateId"() {
            this.validatePlates();
        },
        "value.TrailerPlateId"() {
            this.validatePlates();
        },
        "value.EmployeeAmount"() {
            this.calculate();
        },
        "value.InstallmentCount"() {
            this.calculate();
        },
        "value.PaymentStartPeriod"() {
            this.calculate();
        },
        "value.Date"() {
            this.handleEmployeeChange(null);
        },
        employee: {
            handler(newEmployee) {
                if (newEmployee && newEmployee.VehicleInventoryGarageName) {
                    if(newEmployee.VehicleInventoryGarageId){
                        const garage = {
                            Id: newEmployee.VehicleInventoryGarageId,
                            GarageName: newEmployee.VehicleInventoryGarageName,
                        };
                        this.employeeGarageOption = [garage];
                        this.garageLocation = garage;
                    }
                } else {
                    if (!this.editing || (this.editing && !this.value.VehicleInventoryGarageName)) {
                        this.employeeGarageOption = [];
                        this.garageLocation = null;
                    }
                }
            },
            immediate: true,
        },
    },
    mounted() {
        if (this.value.FullName) {
            this.searchEmployees(this.value.FullName);
        }
        this.getIncidentReasons();
        this.getAllBranches();
        this.getCaseTypes();

        if (this.editing && this.value.VehicleInventoryGarageId && this.value.VehicleInventoryGarageName) {
            const prefilledGarage = {
                Id: this.value.VehicleInventoryGarageId,
                GarageName: this.value.VehicleInventoryGarageName,
            };
            this.selectedGarage = prefilledGarage
            this.garageLocation = prefilledGarage;
        }
        if (this.editing && this.value.IncidentInstallments) {
            this.calculateResult = this.value.IncidentInstallments;
        } else {
            this.calculate();
        }

        this.getCountries();
        this.getProvinces();
        this.getDistricts();
        this.fetchGarages()

        if (this.value.DutyFirmId) {
            let locationId = structuredClone(this.value.DutyFirmLocationId);

            this.loadFirmById(this.value.DutyFirmId).then(() => {
                if (this.firm) {
                    this.getFirmLocation(this.value.DutyFirmId).then(() => {
                        if (locationId) {
                            this.location = this.locations.find((l) => l.Id == locationId);
                        }
                    });
                }
            });
        } else if (this.value.DutyFirm) {
            let locationId = structuredClone(this.value.DutyFirmLocationId);
            this.searchFirms(this.value.DutyFirm)
                .then(() => {
                    this.firm = this.firms.find((f) => f.Id == this.value.DutyFirmId);
                    if (this.firm) {
                        this.getFirmLocation().then(() => {
                            this.location = this.locations.find((l) => l.Id == locationId);
                        });
                    }
                })
                .catch((err) => {
                    console.error("Error loading firm data:", err);
                });
        }
    },
    methods: {
        getCaseTypes() {
            this.caseGetting = true;
            IncidentOperationsApi.FlatList()
                .then((res) => {
                    this.caseGetting = false;
                    this.caseTypes = res.data.Data || [];
                })
                .catch((err) => {
                    this.caseGetting = false;
                });
        },
        validatePositiveAmount(fieldName) {
            if (this.value[fieldName] < 0) {
                this.value[fieldName] = 0;
            }
        },
        handleViewFile(fileUrl) {
            if (typeof fileUrl === "string") {
                this.$emit("view-file", fileUrl);
            }
        },
        updateHasInvoice(event) {
            this.$emit("update-has-invoice", event);
        },
        validatePlates() {
            const { TruckPlateId, TrailerPlateId } = this.value;
            const areEqual = TruckPlateId && TrailerPlateId && TruckPlateId === TrailerPlateId;

            if (areEqual) {
                const msg = "Çekici ve treyler plakası aynı olamaz.";
                this.$set(this.errors, "TruckPlateId", msg);
                this.$set(this.errors, "TrailerPlateId", msg);
            } else {
                this.$delete(this.errors, "TruckPlateId");
                this.$delete(this.errors, "TrailerPlateId");
            }
        },
        calculate() {
            clearTimeout(this.calculateDebounceTimer);
            this.calculateDebounceTimer = setTimeout(() => {
                if (this.value.EmployeeAmount != null && this.value.InstallmentCount != null && this.value.PaymentStartPeriod) {
                    this.calculateResult = [];
                    this.calculating = true;

                    const periodParts = this.value.PaymentStartPeriod.split("/");
                    const month = parseInt(periodParts[0], 10);
                    const year = parseInt(periodParts[1], 10);

                    IncidentOperationsApi.CalculateInstallment(this.value.InstallmentCount, this.value.EmployeeAmount, month, year)
                        .then((res) => {
                            this.calculating = false;
                            if (res.data.Success) {
                                this.calculateResult = res.data.Data;
                            } else {
                                this.$result(res);
                            }
                        })
                        .catch((err) => {
                            this.calculating = false;
                            this.$result(null, err);
                        });
                } else {
                    this.calculateResult = [];
                }
            }, 500);
        },
        disableFutureDates(date) {
            const endOfToday = new Date();
            endOfToday.setHours(23, 59, 59, 999);
            return date > endOfToday;
        },
        searchEmployees(searchKey) {
            return new Promise((resolve, reject) => {
                if (searchKey && this.value.Date) {
                    const search = () => {
                        this.employeeLoading = true;
                        clearTimeout(this.searchOnTableTimer);
                        this.searchOnTableTimer = setTimeout(() => {
                            this.employeeLoading = true;
                            EmployeeOperationsApi.Employee.SearchIncident(searchKey, this.value.Date)
                                .then((res) => {
                                    this.employeeLoading = false;
                                    this.employees = res.data.Data?.map((d) => ({
                                        ...d,
                                        Combine: [d.IdentityNumber, d.FullName].join(" - "),
                                    }));
                                    resolve();
                                })
                                .catch((err) => {
                                    console.log(err);
                                    this.employeeLoading = false;
                                });
                        }, 500);
                    };
                    clearTimeout(this.searchOnTableTimer);
                    this.searchOnTableTimer = setTimeout(() => {
                        search.call(this);
                    }, 500);
                }
            });
        },
        getIncidentReasons() {
            IncidentOperationsApi.Reason.List().then((res) => {
                if (res.data.Success) {
                    this.incidentReasons = res.data.Data;
                }
            });
        },
        getCountries() {
            if ((this.countries || []).length == 0) {
                SystemDataApi.Country().then((res) => {
                    this.countries = res.data.Data;
                    if (this.value.CountryId == null) {
                        this.value.CountryId = this.countries?.find((c) => c.IsDefault)?.Id || null;
                    }
                    this.getProvinces();
                });
            }
        },
        getProvinces() {
            if (this.value.CountryId) {
                SystemDataApi.ProvinceByCountry(this.value.CountryId).then((response) => {
                    this.provinces = response.data.Data;
                });
            } else {
                this.provinces = [];
            }
        },
        getDistricts() {
            if (this.value.ProvinceId) {
                SystemDataApi.District(this.value.ProvinceId).then((res) => {
                    this.districts = res.data.Data;
                });
            } else {
                this.districts = [];
            }
        },
        getFirmLocation(firmId = null) {
            return new Promise((resolve) => {
                const targetFirmId = firmId || this.firm?.Id || this.value.DutyFirmId;

                if (targetFirmId) {
                    this.locationsLoading = true;
                    FirmOperationsApi.Location.List(targetFirmId)
                        .then((response) => {
                            this.locations = response.data.Data || [];
                            this.locationsLoading = false;
                            resolve();
                        })
                        .catch((err) => {
                            console.error("Firm location error:", err);
                            this.locations = [];
                            this.locationsLoading = false;
                            resolve();
                        });
                } else {
                    console.log("No firm ID found, clearing locations");
                    this.locations = [];
                    resolve();
                }
            });
        },
        getAllBranches() {
            CompanyApi.Branch.ListByCode("O").then((res) => {
                if (res.data.Success) {
                    this.allBranches = res.data.Data;

                    if (this.value.OperationalBranchId) {
                        this.selectedBranch = this.allBranches.find((b) => b.Id === this.value.OperationalBranchId);
                    }
                }
            });
        },
        searchFirms(search) {
            return new Promise((resolve) => {
                if (search) {
                    this.firmsLoading = true;
                    FirmOperationsApi.List(search)
                        .then((res) => {
                            this.firms = res.data.Data || [];
                            this.firmsLoading = false;
                            resolve();
                        })
                        .catch((err) => {
                            console.error("Search firms error:", err);
                            this.firms = [];
                            this.firmsLoading = false;
                            resolve();
                        });
                } else {
                    resolve();
                }
            });
        },
        handleEmployeeChange(selectedEmp) {
            const empId = selectedEmp ? selectedEmp.Id : null;
            this.$set(this.value, "EmployeeId", empId);
            this.$set(this.value, "BaseOperationalBranchId", null);

            if (selectedEmp) {
                const branchId = this.$safe(selectedEmp, "OperationalBranchId");
                this.$set(this.value, "OperationalBranchId", branchId);
                this.$set(this.value, "BaseOperationalBranchId", branchId || null);

                if (branchId && this.allBranches) {
                    this.selectedBranch = this.allBranches.find((b) => b.Id == branchId);
                    if (!this.selectedBranch) {
                        this.selectedBranch = { Id: branchId, Name: selectedEmp.OperationalBranchName };
                    }
                } else {
                    this.selectedBranch = null;
                }

                const targetGarageId = selectedEmp.VehicleInventoryGarageId;
                const targetGarageName = selectedEmp.VehicleInventoryGarageName;

                if (targetGarageId) {
                    const tempGarage = { Id: targetGarageId, GarageName: targetGarageName };
                    this.employeeGarageOption = [tempGarage];
                    this.$set(this.value, "VehicleInventoryGarageId", targetGarageId);

                    this.selectedGarage = tempGarage;
                } else {
                    this.employeeGarageOption = [];
                    this.$set(this.value, "VehicleInventoryGarageId", null);
                    this.selectedGarage = null;
                }

                if (branchId) {
                    this.fetchGarages(branchId);
                } else {
                    this.garageLocationsByBranch = [];
                }
            } else {
                this.selectedBranch = null;
                this.selectedGarage = null;
                this.employeeGarageOption = [];
                this.garageLocationsByBranch = [];

                this.$set(this.value, "OperationalBranchId", null);
                this.$set(this.value, "BaseOperationalBranchId", null);
                this.$set(this.value, "VehicleInventoryGarageId", null);
            }
        },

        handleBranchChange(branchObj) {
            const branchId = branchObj ? branchObj.Id : null;
            this.$set(this.value, "OperationalBranchId", branchId);
            this.$set(this.value, "BaseOperationalBranchId", null);
            this.selectedGarage = null;
            this.$set(this.value, "VehicleInventoryGarageId", null);

            this.employeeGarageOption = [];
            this.garageLocationsByBranch = [];

            if (branchId) {
                this.fetchGarages(branchId);
            }
        },

        handleGarageChange(garageObj) {
            this.$set(this.value, "VehicleInventoryGarageId", garageObj ? garageObj.Id : null);
            this.selectedGarage = garageObj;
        },

        fetchGarages(branchId) {
            
            this.garagesLoading = true;
            return VehicleOperationsApi.Garage.List(branchId)
                .then((res) => {
                    if (res.data.Success) {
                        this.garageLocationsByBranch = res.data.Data;
                    }
                })
                .catch((err) => this.$result(null, err))
                .finally(() => (this.garagesLoading = false));
        },
        loadFirmById(firmId) {
            return new Promise((resolve) => {
                if (firmId) {
                    this.firmsLoading = true;
                    FirmOperationsApi.Get(firmId)
                        .then((res) => {
                            if (res.data.Success && res.data.Data) {
                                const existingFirm = this.firms.find((f) => f.Id == firmId);
                                if (!existingFirm) {
                                    this.firms.push(res.data.Data);
                                }
                            }
                            this.firmsLoading = false;
                            resolve();
                        })
                        .catch((err) => {
                            console.error("Load firm by ID error:", err);
                            console.log("Trying alternative approach...");
                            this.firmsLoading = false;
                            resolve();
                        });
                } else {
                    resolve();
                }
            });
        },
    },
    computed: {
        c_caseTypes() {
            const currents = this.caseType.map((s) => s.Id) || [];
            const categories = this.caseType.map((s) => s.CategoryId).filter((v, i, s) => s.indexOf(v) == i) || [];
            return this.caseTypes.filter((s) => currents.includes(s.Id) || !categories.includes(s.CategoryId));
        },
        employee: {
            get: function () {
                return this.employees.find((s) => s.Id == this.value.EmployeeId);
            },
            set: function (value) {
                this.value.EmployeeId = value?.Id || null;
            },
        },
        garageLocation: {
            get: function () {
                return this.garageOptions.find((g) => g.Id == this.value.VehicleInventoryGarageId);
            },
            set: function (value) {
                this.value.VehicleInventoryGarageId = value?.Id || null;
            },
        },
        totalAmountFormatted() {
            const employeeAmount = Number(this.value.EmployeeAmount) || 0;
            const companyAmount = Number(this.value.CompanyAmount) || 0;
            const depositAmount = Number(this.value.EmployeeDepositAmount) || 0;

            const total = employeeAmount + companyAmount + depositAmount;

            return total.toLocaleString("tr-TR", {
                style: "currency",
                currency: "TRY",
            });
        },
        incidentReason: {
            get: function () {
                return this.incidentReasons.find((s) => s.Id == this.value.IncidentReasonId);
            },
            set: function (value) {
                this.value.IncidentReasonId = value?.Id || null;
            },
        },
        truckPlate: {
            get: function () {
                const plates = this.truckPlates || [];
                return plates.find((s) => s.Id == this.value.TruckPlateId);
            },
            set: function (value) {
                this.value.TruckPlateId = value?.Id || null;
            },
        },
        trailerPlate: {
            get: function () {
                const plates = this.trailerPlates || [];
                return plates.find((s) => s.Id == this.value.TrailerPlateId);
            },
            set: function (value) {
                this.value.TrailerPlateId = value?.Id || null;
            },
        },
        installmentCount: {
            get: function () {
                return this.installments.find((s) => s.value == this.value.InstallmentCount);
            },
            set: function (value) {
                this.value.InstallmentCount = value?.value || null;
            },
        },
        country: {
            get: function () {
                return this.countries.find((c) => c.Id == this.value.CountryId);
            },
            set: function (value) {
                if (this.value.CountryId !== (value?.Id || null)) {
                    this.province = null;
                }
                this.value.CountryId = value?.Id || null;
                this.getProvinces();
            },
        },
        caseType: {
            get: function () {
                return this.caseTypes.filter((s) => this.value.CaseTypeIds.includes(s.Id));
            },
            set: function (value) {
                this.value.CaseTypeIds = value?.map((c) => c.Id) || null;
            },
        },
        province: {
            get: function () {
                return this.provinces.find((b) => b.Id == this.value.ProvinceId);
            },
            set: function (value) {
                if (this.value.ProvinceId !== (value?.Id || null)) {
                    this.district = null;
                }
                this.value.ProvinceId = value?.Id || null;
                this.getDistricts();
            },
        },
        district: {
            get: function () {
                return this.districts.find((s) => s.Id == this.value.DistrictId);
            },
            set: function (value) {
                this.value.DistrictId = value?.Id || null;
            },
        },
        salaryPeriods() {
            let periods = [];
            let currentDate = moment();
            for (let i = 0; i < 12; i++) {
                periods.push(currentDate.format("MM/YYYY"));
                currentDate.add(1, "month");
            }
            return periods;
        },
        firm: {
            get: function () {
                return this.firms.find((b) => b.Id == this.value.DutyFirmId);
            },
            set: function (value) {
                this.value.DutyFirmId = value?.Id || null;
                this.location = null;
                this.locations = [];

                if (value?.Id) {
                    const isAlreadyInList = this.firms.some((f) => f.Id === value.Id);
                    if (!isAlreadyInList) {
                        this.firms.push(value);
                    }
                    this.getFirmLocation(value.Id);
                }
            },
        },
        location: {
            get: function () {
                return this.locations.find((b) => b.Id == this.value.DutyFirmLocationId);
            },
            set: function (value) {
                this.value.DutyFirmLocationId = value?.Id || null;
            },
        },
        garageOptions() {
            const branchList = this.garageLocationsByBranch || [];
            const empList = this.employeeGarageOption || [];
            if (branchList.length === 0) return empList;
            if (empList.length > 0) {
                const exists = branchList.some((g) => g.Id == empList[0].Id);
                if (!exists) {
                    return [empList[0], ...branchList];
                }
            }
            return branchList;
        },
    },
};
</script>

<style></style>
